import { backdropClasses, Button, Drawer, drawerClasses, keyframes, MenuItem, styled } from "~/common/mui";
import { LinkButton } from "~/common/components/Link";

const dropDown = keyframes`
  from {
    transform: translateY(-8px);
  }
  to {
    transform: translateY(0);
  }
`;

export const NavigationDrawer = styled(Drawer)(({ theme }) => ({
  [`.${drawerClasses.paper}`]: {
    [theme.breakpoints.down("tablet")]: {
      height: "70vh",
      maxHeight: "700px",
    },
    [theme.breakpoints.between("tablet", "desktop-s")]: {
      width: "45vw",
      maxWidth: "550px",
    },
    [theme.breakpoints.up("desktop-s")]: {
      top: "var(--drawer-offset, 0px)",
      maxHeight: `calc(100dvh - ${theme.spacing(2)} - var(--drawer-offset, 0px))`,
      left: `calc(var(--drawer-left-offset, 0px) - ${theme.spacing(2)} - ${theme.spacing(1.5)})`,
      right: "unset",
      transform: "none !important",
      animation: `${dropDown} ${theme.transitions.duration.enteringScreen}ms ${theme.transitions.easing.easeInOut}`,
      overflow: "hidden",
    },
  },
  [theme.breakpoints.up("desktop-s")]: {
    top: "var(--drawer-offset, 0px)",
  },
  [`.${backdropClasses.root}`]: {
    [theme.breakpoints.up("desktop-s")]: {
      top: "var(--drawer-offset, 0px)",
    },
  },
})) as typeof Drawer;

export const DrawerFooter = styled("div")(({ theme }) => ({
  marginTop: "auto",
  padding: theme.spacing(2),
  paddingTop: 0,
}));

export const NavigationLevels = styled("div")(({ theme }) => ({
  position: "relative",
  display: "grid",
  overflow: "hidden",
  padding: theme.spacing(2),
  width: "100%",

  [theme.breakpoints.down("desktop-s")]: {
    "& > *": {
      gridRow: "1",
      gridColumn: "1",
    },
  },

  [theme.breakpoints.up("desktop-s")]: {
    gridAutoColumns: "288px",
    gridAutoFlow: "column",
    gap: theme.spacing(2),
  },
  [theme.breakpoints.up("desktop-m")]: {
    gridAutoColumns: "358px",
  },
}));

export const NavigationLevel = styled("div", {
  shouldForwardProp: () => true,
})(({ theme }) => ({
  position: "relative",
  overflow: "auto",

  [theme.breakpoints.up("desktop-s")]: {
    gridColumn: "var(--desktop-column, 1)",
    gridRow: 1,
  },
}));

export const NavigationLevelTitle = styled("a", {
  shouldForwardProp: () => true,
})(({ theme }) => ({
  padding: theme.spacing(1, 1.5),
  display: "inline-flex",
  gap: theme.spacing(1),
  color: theme.palette.text.primary,
  ...theme.typography.titleMedium,

  ["&:hover"]: {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    background: "transparent",
  },
}));

export const NavigationItem = styled(MenuItem)(({ theme }) => ({
  ...theme.typography.bodyLarge,
  padding: theme.spacing(1, 1.5),

  display: "flex",
  gap: theme.spacing(1.5),
  alignItems: "center",
  width: "100%",
  minWidth: 0,
  whiteSpace: "pre-wrap",
  color: theme.palette.text.primary,

  ["&:hover"]: {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    background: "transparent",
  },

  ["&.Mui-selected"]: {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    background: "none",

    ["&:hover"]: {
      background: "transparent",
    },
  },
  ["> img.icon"]: {
    width: 24,
    height: 24,
    marginRight: -4,
    objectFit: "cover",
  },
}));

export const BackButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,

  ["&:hover"]: {
    background: "transparent",
    textDecoration: "underline",
  },
}));

export const DrawerHeader = styled("div")(({ theme }) => ({
  color: theme.palette.primary.main,
  paddingRight: theme.spacing(1.5),
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  ...theme.typography.bodyLarge,
  padding: theme.spacing(2, 2, 0, 2),
  marginBottom: theme.spacing(-1),
}));

export const DesktopNavigationMenu = styled("nav")(({ theme }) => ({
  display: "inline-flex",
  gap: theme.spacing(4),
}));

export const DesktopNavigationMenuItem = styled(LinkButton)(({ theme }) => ({
  ...theme.typography.bodyMedium,
  display: "inline-flex",
  color: theme.palette.text.primary,
  position: "relative",

  ["&.selected"]: {
    color: theme.palette.primary.main,

    ["&::after"]: {
      content: '""',
      position: "absolute",
      bottom: "calc(-1 * var(--bar-offset, 0px))",
      left: "0",
      width: "100%",

      borderBottom: `3px solid ${theme.palette.primary.main}`,
    },
  },

  ".saleTab": {
    color: theme.palette.error.main,
  },
}));
